import React from "react";
import { useTranslation } from "react-i18next";
import Badge from "components/Badge";

/** Chip shown wherever a value is genuinely missing (never rendered as 0). */
export default function NotAvailableChip() {
  const { t } = useTranslation();
  return (
    <Badge type="info" size="small">
      {t("levels.notAvailable")}
    </Badge>
  );
}
